import React from "react";
import { imageSet } from "../../helper/Images";

import "./lensCareGuide.scss";

const Card = ({ item }) => {
  return (
    <React.Fragment>
      <li  className={`lcguide--content__item`}>
        <figure className="lcguide--image__wrapper">
          <img
            className="lcguide--image img-responsive"
            src={imageSet[item.img]}
            alt=''
          />
          <figcaption className="lcguide--image__caption">
            {item.type}
          </figcaption>
        </figure>
        <div
          className="lcguide--content__description"
          dangerouslySetInnerHTML={{ __html: item.desc }}
        />
      </li>
    </React.Fragment>
  );
};

export default Card;
